import React, { FC } from 'react';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, Stripe } from '@stripe/stripe-js';

import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import { ServiceTypes } from '@pharmaplan/common';

const isSelfService = ServiceHandler.getService() === ServiceTypes.self;

const { REACT_APP_STRIPE_PUBLIC_KEY } = process.env ?? {};
export const stripePromise: Promise<null | Stripe> | null = isSelfService
  ? loadStripe(REACT_APP_STRIPE_PUBLIC_KEY ?? '')
  : null;

interface IStripeWrapper {
  children: React.ReactNode;
}

const StripeWrapper: FC<IStripeWrapper> = ({ children }) => {
  if (isSelfService) {
    return <Elements stripe={stripePromise}>{children}</Elements>;
  }
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  );
};

export default StripeWrapper;
